import { render, staticRenderFns } from "./LogVersion.vue?vue&type=template&id=7b5f244c&"
import script from "./LogVersion.vue?vue&type=script&lang=js&"
export * from "./LogVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports